module.exports = __webpack_public_path__ + "fonts/479970f.woff2";